import { apiClient } from '~/lib/api/client';

export interface ApplicationStatusDistributionResponse {
  year: number;
  approved: number;
  reject: number;
  pending: number;
  assigned: number;
}

export interface YearlyRegistrationTrendItem {
  year: number;
  total: number;
}

export interface YearlyRegistrationTrendResponse {
  items: YearlyRegistrationTrendItem[];
}

export interface RegionalNurseryDistrictItem {
  districtId: string;
  districtName: string;
  applicationsSubmitted: number;
  permitsIssued: number;
}

export interface RegionalNurseryDistributionItem {
  regionalCode: string;
  districts: RegionalNurseryDistrictItem[];
}

export interface RegionalNurseryDistributionResponse {
  items: RegionalNurseryDistributionItem[];
}

export interface NewVsRenewalsItem {
  year: number;
  newApplication: number;
  renewalApplication: number;
}

export interface NewVsRenewalsResponse {
  items: NewVsRenewalsItem[];
}

export interface FormCompletionSummaryResponse {
  year: number;
  completedCn02: number;
  completedCn03: number;
  completedCn04: number;
  completedCn05: number;
  completedCn06: number;
}

export interface InspectorPerformanceItem {
  teaInspectorName: string;
  completed: number;
}

export interface InspectorPerformanceResponse {
  items: InspectorPerformanceItem[];
}

export interface RegionalYearQueryParams {
  regionalCode?: string;
  year?: number;
}

export interface RegionalQueryParams {
  regionalCode?: string;
}

export async function getApplicationStatusDistribution(
  params?: RegionalYearQueryParams
): Promise<ApplicationStatusDistributionResponse> {
  const res = await apiClient.get<ApplicationStatusDistributionResponse>(
    '/analytics/application-status-distribution',
    { params }
  );
  return res.data;
}

export async function getYearlyRegistrationTrend(): Promise<YearlyRegistrationTrendResponse> {
  const res = await apiClient.get<YearlyRegistrationTrendResponse>(
    '/analytics/yearly-registration-trend'
  );
  return res.data;
}

export async function getRegionalNurseryDistribution(): Promise<RegionalNurseryDistributionResponse> {
  const res = await apiClient.get<RegionalNurseryDistributionResponse>(
    '/analytics/regional-nursery-distribution'
  );
  return res.data;
}

export async function getNewVsRenewals(
  params?: RegionalYearQueryParams
): Promise<NewVsRenewalsResponse> {
  const res = await apiClient.get<NewVsRenewalsResponse>('/analytics/new-vs-renewals', { params });
  return res.data;
}

export async function getFormCompletionSummary(
  params?: RegionalYearQueryParams
): Promise<FormCompletionSummaryResponse> {
  const res = await apiClient.get<FormCompletionSummaryResponse>(
    '/analytics/form-completion-summary',
    { params }
  );
  return res.data;
}

export async function getInspectorPerformance(
  params?: RegionalQueryParams
): Promise<InspectorPerformanceResponse> {
  const res = await apiClient.get<InspectorPerformanceResponse>(
    '/analytics/inspector-performance',
    { params }
  );
  return res.data;
}
